import React from 'react';

import { Link, Tooltip } from '@mui/material';

type Props = {
  url: string;
  children: React.ReactNode;
};

export class GoogleMapsLink extends React.Component<Props> {
  render() {
    return (
      <Tooltip title="Open lat/lng in Google Maps in a new tab">
        <Link href={this.props.url} target="_blank">
          {this.props.children}
        </Link>
      </Tooltip>
    );
  }
}
